import type { SpinResponse } from "@slot/client-engine";
import { MergeRoundBuilder } from "../../MergeRoundBuilder";
import { OFFLINE_ROUND } from "../offlineRound";

/**
 * The cap and the H1 exception, across the middle of the board: a 10-cell L4 block (two rows of five) would make five
 * pairs but makes four H1, the outputs' cap — each top candy dropping into the one below it — and its last column's two
 * L4 stay. The row of four H1 and the H1 that falls onto it make a 5-cell H1 cluster, which pays ×10 on its badges and
 * merges into exactly one FS, every other H1 flying into its centre. 1.50 + 10.00 = 11.50, the nice tier.
 */
export function mergeH1Scatter(): SpinResponse {
  return new MergeRoundBuilder({ roundId: "merge-h1-scatter", ...OFFLINE_ROUND })
    .baseSpin({
      board: [
        ["L1", "L3", "L2", "H2", "L1", "L2"],
        ["L2", "L1", "H1", "L3", "L2", "H3"],
        ["L3", "L4", "L4", "L4", "L4", "L4"],
        ["H2", "L4", "L4", "L4", "L4", "L4"],
        ["L1", "L2", "L3", "L1", "H3", "L1"],
        ["L3", "H4", "L1", "L2", "L3", "L2"],
      ],
      refill: [[], ["H4", "L3"], ["L4", "L2"], ["L1", "L4"], ["H2", "L3"], []],
    })
    .build();
}
